import { Controller, useFormContext } from 'react-hook-form'
import { useEffect, useLayoutEffect, useState } from 'react'
import { InputLabelStyled, SpanOptional } from '../styles'
import {
  Divider,
  FormControlLabel,
  Grid,
  Icon,
  ListItemText,
  MenuItem,
  palette,
  RadioGroup,
  Select,
  Typography,
  theme,
  Checkbox,
  IconTooltip,
  FormGroup,
} from '@yuno/design-system-web'
import {
  ChecboxContainer,
  CheckboxContainer,
  CheckboxCustomStyled,
  CheckboxLabelStyled,
  CheckboxStyled,
  Condition,
  FormControlLabelStyled,
  Header,
  IconTooltipStyled,
  InputAvailableFields,
  InputContainer,
  PaymentMethodsContainer,
  RadioButtonContainer,
  RadioMuiStyled,
  Title,
  TooltipContainer,
} from '../connection-form/styles'
import { ReturnNextLevel } from './connections_return_next_level'
import { useToggleEnvironment } from '@yuno/dashboard-container-mfe'
import { useTestKeysV2 } from '../../hooks/key-testV2.hook'
import { IconKeyTestOptionsV2 } from '../connection-form/connection-icon-test-keysV2'
import { useTranslation } from 'react-i18next'

export const ConnectionsSwitchFields = ({
  item,
  index,
  options,
  connectionResponse,
  isAsync,
  testKeyValues,
  currentMode,
  toggleState,
  setToggleState,
  setIsAvailableTest,
  isAvailableTest,
  setParams,
  params,
  optional = false,
  tooltip = null,
  ...fields
}) => {
  const [showNextLevel, setShowNextLevel] = useState(false)
  const [optionsState, setOptions] = useState(options)
  const [disabled, setDisabled] = useState(false)
  const { getModeStatus } = useToggleEnvironment()
  const { t, i18n } = useTranslation()
  const currentLanguage = i18n.language

  const {
    register,
    control,
    setValue,
    getValues,
    resetField,
    trigger,
    reset,
    formState: { errors },
    getFieldState,
  } = useFormContext()

  const { handleTestKeyButton, resetTestKeyProps } = useTestKeysV2({
    getModeStatus,
    params,
    isAvailableTest,
    testKeyValues,
    item,
    country: getValues('COUNTRY'),
    setValue,
    resetField,
    setToggleState,
    trigger,
    connectionResponse,
    setIsAvailableTest,
    getFieldState,
  })

  const resetForm = (target, items, resetObj) => {
    let cloneObj = items
    let name = ''
    let objReset = resetObj ?? {}
    const value = getValues(target.name)
    const values = getValues()
    if (target) {
      cloneObj = items.options.find((option) => option.key === value)
    }
    cloneObj?.params?.map((param) => {
      objReset[param.param_id] = ''
      name = param.param_id
      cloneObj = param
    })
    reset({ ...values, [target.name]: target.value, params: null })
  }

  const getTestCredentials = () => {
    if (testKeyValues && testKeyValues.length > 0) {
      let newDataForm = {}
      let counter = 0
      const actualForm = getValues()
      const testValuesArray = Object.keys(testKeyValues[0])
      let listParameters = testKeyValues

      testValuesArray.map((parameter) => {
        if (!listParameters.length) {
          return
        }
        if (listParameters.length === 1) {
          listParameters = listParameters[0]
          return
        }
        listParameters = listParameters?.filter(
          (value) =>
            value[parameter] === '' ||
            value[parameter] === getValues(parameter.toUpperCase()),
        )
      })

      if (listParameters) {
        delete listParameters.params
        delete actualForm.name
        delete actualForm.params_with_test_values
        Object.keys(actualForm).map((key) => {
          newDataForm[key.toLocaleLowerCase()] = actualForm[key]
        })
        for (const param in listParameters) {
          if (
            !newDataForm[param] &&
            (listParameters[param] === '' ||
              listParameters[param] === 'GLOBAL' ||
              listParameters[param] === null)
          ) {
            counter++
          }
          if (listParameters[param] === newDataForm[param]) {
            counter++
          }
        }
        if (
          Object.keys(listParameters).length != 0 &&
          counter === Object.keys(listParameters).length
        ) {
          setIsAvailableTest(true)
        } else {
          setIsAvailableTest(false)
        }
      }
    }
  }

  const handleChange = ({ target }) => {
    resetForm(target, item, null)
    setOptions({ ...optionsState })
    setValue(target.name, target.value)
    setShowNextLevel(true)
    resetTestKeyProps()
    if (getModeStatus() === 'ON') {
      getTestCredentials()
    }
  }

  const renderValue = (value) => {
    const render = item.options.find((option) => option.key === value)
    return render
      ? render.value
      : typeof item.placeholder !== 'string'
      ? item.placeholder[currentLanguage.toLocaleUpperCase()]
      : item.placeholder
  }

  const returnItem = (options) => {
    return options?.find((option) => option.key === getValues()[item.param_id])
      ?.params
  }

  const returnItemMultiple = (options) => {
    const valuesSelected = getValues(item.param_id)
    const paramsOptions = []
    options.forEach((option) => {
      if (
        valuesSelected &&
        Array.isArray(valuesSelected) &&
        valuesSelected.find((value) => value === option.key)
      ) {
        paramsOptions.push(...option.params)
      }
    })
    return paramsOptions
  }

  const setEditionValues = () => {
    if (
      item.field_type === 'TEXT' ||
      item.field_type === 'PASSWORD' ||
      item.field_type === 'MULTIPLE_CHECK'
    ) {
      const value = connectionResponse.params.find(
        (param) => param.param_id === item.param_id,
      )?.value
      setValue(item.param_id, value)
      reset({ ...getValues(), [item.param_id]: value })
    }
  }

  const existParam = (param_id) => {
    const exist = params?.some((item) => item.param_id === param_id)
    return exist
  }

  useEffect(() => {
    if (connectionResponse) {
      setEditionValues()
    }
    if (
      (item.field_type === 'TEXT' || item.field_type === 'PASSWORD') &&
      !existParam(item.param_id)
    ) {
      params.push({ param_id: item.param_id })
      setParams(params)
    }
  }, [])

  useEffect(() => {
    showNextLevel &&
      (connectionResponse ||
        !item.editable_field ||
        !!item.enabled ||
        isAsync) &&
      setDisabled(true)
  }, [showNextLevel])

  const defaultValue = () => {
    if (connectionResponse) {
      const response = Array.isArray(
        connectionResponse[item.param_id.toLowerCase()],
      )
        ? connectionResponse[item.param_id.toLowerCase()][0]
        : connectionResponse[item.param_id.toLowerCase()]
      return response
    }
    return null
  }

  const [selectedValues, setSelectedValues] = useState<string[]>([])

  const handleChangeMultiSelect = (event) => {
    const {
      target: { value },
    } = event
    let copySelectedValues = []
    value.forEach((element) => {
      const index = selectedValues.indexOf(element)
      if (index > -1) {
        copySelectedValues = selectedValues.splice(index, 1)
      } else {
        copySelectedValues.push(element)
      }
    })
    setSelectedValues([...copySelectedValues])

    resetForm(event.target, item, null)
    setOptions({ ...optionsState })
    setValue(item.param_id, copySelectedValues)
    setShowNextLevel(true)
    resetTestKeyProps()
    if (getModeStatus() === 'ON') {
      getTestCredentials()
    }
  }

  const defaultValueMultiple = () => {
    if (item) {
      const selectedOptions = []
      let hasParams = false
      item.options.forEach((option) => {
        if (option.selected) {
          selectedOptions.push(option.key)
          if (option.params.length > 0) {
            hasParams = true
          }
        }
      })
      if (hasParams) {
        setOptions({ ...optionsState })
        setValue(item.param_id, selectedOptions)
        setShowNextLevel(true)
        resetTestKeyProps()
        if (getModeStatus() === 'ON') {
          getTestCredentials()
        }
      }
      setSelectedValues(selectedOptions)
      return selectedOptions
    }
    return []
  }

  const defaultChecked = (paymentMethod) => {
    if (connectionResponse) {
      const value = connectionResponse.params.find(
        (param) => param.param_id === item.param_id,
      )?.value
      return value?.includes(paymentMethod.key)
    } else if (paymentMethod.selected) {
      setValue(`${item.param_id}.${paymentMethod.key}`, paymentMethod.selected)
      return true
    }
    return false
  }
  const defaultCheckbox = () => {
    if (connectionResponse) {
      const value = connectionResponse.params.find(
        (param) => param.param_id === item.param_id,
      )?.value
      return value === 'true'
    } else if (item && item.cheked === 'true') {
      setValue(item.param_id, item.cheked === 'true')
      return item.cheked === 'true'
    }
    return false
  }

  const defaultValueRadio = () => {
    if (connectionResponse) {
      const option = connectionResponse.params.find(
        (param) => param.param_id === item.param_id,
      )
      if (option && option.value) {
        setValue(item.param_id, option.value)
      }
    } else if (item) {
      const option = item.options.find((param) => param.selected)
      if (option) {
        setValue(item.param_id, option.key)
        return option.key
      }
    }
    return ''
  }

  useEffect(() => {
    if (connectionResponse) {
      setShowNextLevel(true)
      reset({ ...getValues(), name: connectionResponse.connection_name })
      const option = connectionResponse.params.find(
        (param) => param.param_id === item.param_id,
      )
      if (option && option.value && option.value === 'input_test_value') {
        setIsAvailableTest(true)
      }
      if (option && option.param_id === 'CHECKBOX') {
        setEnabledCheckbox(option.value === 'true')
      }
    }
    getTestCredentials()
  }, [])

  const getValuesMultiSelect = () => {
    if (item) {
      const selectedOptions = []
      let hasParams = false
      item.options.forEach((option) => {
        if (option.selected) {
          selectedOptions.push(option.key)
          if (option.params.length > 0) {
            hasParams = true
          }
        }
      })
      setValue(`param_id.${item.param_id}`, selectedOptions)
      return selectedOptions
    }
  }

  const [enabledCheckbox, setEnabledCheckbox] = useState(
    currentMode !== 'create' && item.param_id === 'TEST_CHECK_PARAM'
      ? true
      : defaultCheckbox(),
  )

  const handleChangeCheckbox = () => {
    setEnabledCheckbox(!enabledCheckbox)
    setValue(item.param_id, !enabledCheckbox)
    item.params.forEach((param) => {
      setValue(param.param_id, '')
    })
  }

  const optionalItem = item.optional ? {} : { required: true }
  useLayoutEffect(() => {
    if (getValues('params_with_test_values') === true) {
      if (item.field_type === 'CHECKBOX') {
        setEnabledCheckbox(false)
        setValue(item.param_id, false)
        item.params.forEach((param) => {
          setValue(param.param_id, '')
        })
      }
    }
  }, [getValues()])

  const getItemsCheckbox = (params) => {
    const items = params?.map((param) => {
      return {
        ...param,
        optional: !enabledCheckbox ? true : param.optional,
        enable: enabledCheckbox,
        editable_field: param.editable_field,
      }
    })
    return items
  }

  const findValiteCheckbox = (paramId: string) => {
    if (item.optional === false) {
      const valuesOptions = getValues(paramId)
      let validate = false
      Object.keys(valuesOptions).forEach(value => {
        if (value) {
          validate = true
        }
      });
      return validate
    }
    return true
  }

  switch (item.field_type) {
    case 'MULTIPLE_SELECT':
      return (
        <>
          <Grid item xs={12} sx={{ paddingTop: '20px' }}>
            <TooltipContainer>
              {item.tooltip && (
                <IconTooltipStyled
                  name="Info"
                  size="16"
                  tooltip={{
                    title:
                      typeof item.tooltip !== 'string'
                        ? item.tooltip[currentLanguage.toLocaleUpperCase()]
                        : item.tooltip,
                    children: null,
                  }}
                />
              )}
              <InputLabelStyled id={item.param_id}>
                {typeof item.label !== 'string'
                  ? item.label[currentLanguage.toLocaleUpperCase()]
                  : item.label}
                {item.optional ? (
                  <SpanOptional>{t('optional')}</SpanOptional>
                ) : (
                  ''
                )}
              </InputLabelStyled>
            </TooltipContainer>
            <Select
              multiple
              labelId={item.param_id}
              id={item.param_id}
              name={item.param_id}
              defaultValue={defaultValueMultiple}
              fullWidth
              variant="outlined"
              displayEmpty
              value={
                getValues(item.param_id)
                  ? getValues(item.param_id)
                  : getValuesMultiSelect()
              }
              MenuProps={{ id: `${item.param_id}-menu` }}
              error={!!errors[item.param_id]}
              renderValue={(selected) => `${selected.length} ${t('selected')}`}
              {...register(item.param_id as never, {
                ...optionalItem,
              })}
              disabled={!item.enable}
              onChange={handleChangeMultiSelect.bind(this)}
            >
              {options?.map((option) => (
                <MenuItem
                  style={{
                    backgroundColor: theme.palette.neutral.white[0],
                    color: theme.palette.neutral.black,
                  }}
                  key={option.key}
                  value={option.key}
                  disabled={!option.enable}
                >
                  <CheckboxStyled
                    checked={
                      getValues(item.param_id)
                        ? getValues(item.param_id).indexOf(option.key) > -1
                        : selectedValues.indexOf(option.key) > -1
                    }
                    disabled={!option.enable}
                  />
                  <ListItemText
                    primary={
                      typeof option.value !== 'string'
                        ? option.value[currentLanguage.toLocaleUpperCase()]
                        : option.value
                    }
                  />
                </MenuItem>
              ))}
            </Select>
          </Grid>
          {showNextLevel && (
            <ReturnNextLevel
              item={returnItemMultiple(item.options)}
              handleChange={handleChange}
              connectionResponse={connectionResponse}
              isAsync={isAsync}
              testKeyValues={testKeyValues}
              currentMode={currentMode}
              toggleState={toggleState}
              setToggleState={setToggleState}
              isAvailableTest={isAvailableTest}
              setIsAvailableTest={setIsAvailableTest}
              params={params}
              setParams={setParams}
            />
          )}
        </>
      )
    case 'SELECT':
      return (
        <>
          <Grid item xs={12} sx={{ paddingTop: '20px' }}>
            <TooltipContainer>
              {item.tooltip && (
                <IconTooltipStyled
                  name="Info"
                  size="16"
                  tooltip={{
                    title:
                      typeof item.tooltip !== 'string'
                        ? item.tooltip[currentLanguage.toLocaleUpperCase()]
                        : item.tooltip,
                    children: null,
                  }}
                />
              )}
              <InputLabelStyled id={item.param_id}>
                {typeof item.label !== 'string'
                  ? item.label[currentLanguage.toLocaleUpperCase()]
                  : item.label}
                {item.optional ? (
                  <SpanOptional>{t('optional')}</SpanOptional>
                ) : (
                  ''
                )}
              </InputLabelStyled>
            </TooltipContainer>
            <Select
              labelId={item.param_id}
              id={item.param_id}
              name={item.param_id}
              value={
                getValues()[item.param_id]
                  ? getValues()[item.param_id]
                  : defaultValue()
              }
              defaultValue={defaultValue}
              fullWidth
              variant="outlined"
              displayEmpty
              MenuProps={{ id: `${item.param_id}-menu` }}
              error={!!errors[item.param_id]}
              renderValue={renderValue}
              {...register(item.param_id as never, {
                ...optionalItem,
              })}
              onChange={handleChange.bind(this)}
              disabled={disabled}
            >
              {options?.map((option) => {
                return (
                  <MenuItem
                    key={option.key}
                    value={option.key}
                    selected={option.selected}
                  >
                    {typeof option.value !== 'string'
                      ? option.value[currentLanguage.toLocaleUpperCase()]
                      : option.value}
                  </MenuItem>
                )
              })}
            </Select>
          </Grid>
          {showNextLevel && (
            <ReturnNextLevel
              item={returnItem(item.options)}
              handleChange={handleChange}
              connectionResponse={connectionResponse}
              isAsync={isAsync}
              testKeyValues={testKeyValues}
              currentMode={currentMode}
              toggleState={toggleState}
              setToggleState={setToggleState}
              isAvailableTest={isAvailableTest}
              setIsAvailableTest={setIsAvailableTest}
              params={params}
              setParams={setParams}
            />
          )}
        </>
      )
    case 'TEXT':
      return (
        <>
          <Grid item xs={12} sx={{ paddingTop: '20px' }}>
            <InputContainer>
              <TooltipContainer>
                {item.tooltip && (
                  <IconTooltipStyled
                    name="Info"
                    size="16"
                    tooltip={{
                      title:
                        typeof item.tooltip !== 'string'
                          ? item.tooltip[currentLanguage.toLocaleUpperCase()]
                          : item.tooltip,
                      children: null,
                    }}
                  />
                )}
                <InputLabelStyled id={item.param_id}>
                  {typeof item.label !== 'string'
                    ? item.label[currentLanguage.toLocaleUpperCase()]
                    : item.label}
                  {item.optional ? (
                    <SpanOptional>{t('optional')}</SpanOptional>
                  ) : (
                    ''
                  )}
                </InputLabelStyled>
              </TooltipContainer>
              {/* @ts-ignore */}
              <InputAvailableFields
                key={`input.${index}`}
                type={isAvailableTest && toggleState ? 'password' : 'text'}
                placeholder={
                  typeof item.placeholder !== 'string'
                    ? item.placeholder[currentLanguage.toLocaleUpperCase()]
                    : item.placeholder
                }
                {...register(item.param_id as never, {
                  ...optionalItem,
                })}
                fullWidth
                error={!isAvailableTest && !!errors[item.param_id]}
                helperText={
                  isAvailableTest
                    ? ''
                    : errors[item.param_id]
                    ? t('fillField')
                    : ''
                }
                disabled={
                  !item.editable_field ||
                  connectionResponse?.test_credentials ||
                  isAsync ||
                  toggleState ||
                  !item.enable
                }
              />
              {isAvailableTest && item.enable && (
                <IconKeyTestOptionsV2
                  key={`icon.${index}`}
                  isMainInput={index === 0}
                  hasTestValue={isAvailableTest}
                  isCreateMode={currentMode === 'create'}
                  resetTestKeyProps={resetTestKeyProps}
                  handleTestKeyButton={handleTestKeyButton.bind(null)}
                  toggleState={toggleState}
                />
              )}
            </InputContainer>
          </Grid>
        </>
      )
    case 'CHECKBOX':
      return (
        <>
          <Grid item xs={12} sx={{ paddingTop: '20px' }}>
            {/* @ts-ignore */}
            <CheckboxContainer>
              <CheckboxCustomStyled
                // checked={enabledCheckbox}
                defaultChecked={defaultCheckbox()}
                key={`input.${index}`}
                onClick={handleChangeCheckbox}
                {...register(item.param_id as never, {
                  ...optionalItem,
                })}
                disabled={
                  (currentMode !== 'create' && !item.editable_field) ||
                  connectionResponse?.test_credentials ||
                  isAsync ||
                  toggleState ||
                  !item.enable
                }
              />
              <TooltipContainer>
                {item.tooltip && item.tooltip.length > 0 && (
                  <IconTooltipStyled
                    name="Info"
                    size="16"
                    marginBottom={false}
                    tooltip={{ title: item.tooltip, children: null }}
                  />
                )}
              </TooltipContainer>
              <Typography variant="caption" id={item.param_id}>
                {typeof item.label !== 'string'
                  ? item.label[currentLanguage.toLocaleUpperCase()]
                  : item.label}
              </Typography>
            </CheckboxContainer>
          </Grid>
          {enabledCheckbox && item.params && item.params.length > 0 && (
            <ReturnNextLevel
              item={getItemsCheckbox(item.params)}
              handleChange={handleChange}
              connectionResponse={connectionResponse}
              isAsync={isAsync}
              testKeyValues={testKeyValues}
              currentMode={currentMode}
              toggleState={toggleState}
              setToggleState={setToggleState}
              isAvailableTest={false}
              setIsAvailableTest={setIsAvailableTest}
              params={params}
              setParams={setParams}
            />
          )}
        </>
      )
    case 'PASSWORD':
      return (
        <>
          <Grid item xs={12} sx={{ paddingTop: '20px' }}>
            <InputContainer>
              <TooltipContainer>
                {item.tooltip && (
                  <IconTooltipStyled
                    name="Info"
                    size="16"
                    tooltip={{
                      title:
                        typeof item.tooltip !== 'string'
                          ? item.tooltip[currentLanguage.toLocaleUpperCase()]
                          : item.tooltip,
                      children: null,
                    }}
                  />
                )}
                <InputLabelStyled id={item.param_id}>
                  {typeof item.label !== 'string'
                    ? item.label[currentLanguage.toLocaleUpperCase()]
                    : item.label}
                  {item.optional ? (
                    <SpanOptional>{t('optional')}</SpanOptional>
                  ) : (
                    ''
                  )}
                </InputLabelStyled>
              </TooltipContainer>
              {/* @ts-ignore */}
              <InputAvailableFields
                key={`input.${index}`}
                type={'password'}
                placeholder={
                  typeof item.placeholder !== 'string'
                    ? item.placeholder[currentLanguage.toLocaleUpperCase()]
                    : item.placeholder
                }
                {...register(item.param_id as never, {
                  ...optionalItem,
                })}
                fullWidth
                error={false}
                helperText={''}
                disabled={
                  !item.editable_field ||
                  connectionResponse?.test_credentials ||
                  toggleState
                }
              />
              {isAvailableTest && (
                <IconKeyTestOptionsV2
                  key={`icon.${index}`}
                  isMainInput={index === 0}
                  hasTestValue={isAvailableTest}
                  isCreateMode={currentMode === 'create'}
                  resetTestKeyProps={resetTestKeyProps}
                  handleTestKeyButton={handleTestKeyButton}
                  toggleState={toggleState}
                />
              )}
            </InputContainer>
          </Grid>
        </>
      )
    case 'MULTIPLE_CHECK':
      return (
        <>
          <TooltipContainer>
            {item.tooltip && (
              <IconTooltipStyled
                name="Info"
                size="16"
                tooltip={{
                  title:
                    typeof item.tooltip !== 'string'
                      ? item.tooltip[currentLanguage.toLocaleUpperCase()]
                      : item.tooltip,
                  children: null,
                }}
              />
            )}
            <InputLabelStyled id={item.param_id}>
              {typeof item.label !== 'string'
                ? item.label[currentLanguage.toLocaleUpperCase()]
                : item.label}
              {item.optional ? (
                <SpanOptional>{t('optional')}</SpanOptional>
              ) : (
                ''
              )}
            </InputLabelStyled>
          </TooltipContainer>
          <PaymentMethodsContainer>
            {options.map((paymentMethod, index) => {
              if (paymentMethod.selected) {
                setValue(
                  `${item.param_id}.${paymentMethod.key}`,
                  paymentMethod.selected,
                )
              }
              return (
                <ChecboxContainer>
                  <FormControlLabel
                    key={paymentMethod.key}
                    control={
                      <CheckboxStyled
                        size="medium"
                        {...register(
                          `${item.param_id}.${paymentMethod.key}` as never,
                          { validate: () => findValiteCheckbox(item.param_id) },
                        )}
                        defaultChecked={defaultChecked(paymentMethod)}
                        disabled={!paymentMethod.enable}
                      />
                    }
                    label={
                      <Typography variant="caption">
                        {paymentMethod.value}
                      </Typography>
                    }
                    labelPlacement="end"
                  />
                </ChecboxContainer>
              )
            })}
          </PaymentMethodsContainer>
        </>
      )
    case 'RADIO':
      return (
        <>
          <TooltipContainer>
            {item.tooltip && (
              <IconTooltipStyled
                name="Info"
                size="16"
                tooltip={{
                  title:
                    typeof item.tooltip !== 'string'
                      ? item.tooltip[currentLanguage.toLocaleUpperCase()]
                      : item.tooltip,
                  children: null,
                }}
              />
            )}
            <InputLabelStyled id={item.param_id}>
              {typeof item.label !== 'string'
                ? item.label[currentLanguage.toLocaleUpperCase()]
                : item.label}
              {item.optional ? (
                <SpanOptional>{t('optional')}</SpanOptional>
              ) : (
                ''
              )}
            </InputLabelStyled>
          </TooltipContainer>
          <RadioButtonContainer>
            <Controller
              control={control}
              name={item.param_id}
              render={({ field }) => (
                <RadioGroup {...field} defaultValue={defaultValueRadio}>
                  {options.map((option, index) => (
                    <FormControlLabelStyled
                      key={index}
                      value={option.key}
                      label={
                        typeof option.value !== 'string'
                          ? option.value[currentLanguage.toLocaleUpperCase()]
                          : option.value
                      }
                      control={
                        <RadioMuiStyled
                          checked={getValues(item.param_id) === option.key}
                          checkedIcon={
                            <Icon
                              name="CheckCircle"
                              color={palette.vivid.brand}
                              weight="fill"
                              size={'16px'}
                            />
                          }
                        />
                      }
                    />
                  ))}
                </RadioGroup>
              )}
            />
          </RadioButtonContainer>
        </>
      )
    case 'DIVIDER':
      return <Divider sx={{ background: palette.grey[2], margin: '20px 0' }} />
    case 'ONLY_TO_SHOW':
      return (
        <>
          <Header>
            <Title> {t('configurations')}</Title>
            <Condition>{t('required')}</Condition>
          </Header>
        </>
      )
    default:
      break
  }
}
